import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getUniqueSources from '@anm/helpers/getUniqueSources';
import checkCanDownload from '../checkCanDownload';
var controlsMap = {
  logo: 'logo',
  speed: 'settings-speed',
  volume: 'volume',
  quality: 'settings-quality',
  download: 'download',
  settings: 'settings',
  fullScreen: 'fullscreen',
  currentTime: 'current-time',
  playbarButton: 'playbar-button',
  bigPlayButton: 'play-large',
  smallPlayButton: 'play'
};
var endBehaviorMap = {
  loop: {
    resetOnEnd: false,
    loop: {
      active: true
    }
  },
  showLastFrame: {
    resetOnEnd: false,
    loop: {
      active: false
    }
  },
  showThumbnail: {
    resetOnEnd: false,
    loop: {
      active: false
    }
  }
};

var filterControls = function filterControls(playbar) {
  return Object.keys(playbar).filter(function (control) {
    return !playbar[control];
  }).map(function (control) {
    return controlsMap[control];
  });
};

var checkSettingsExists = function checkSettingsExists(_ref, sources) {
  var speed = _ref.speed,
      quality = _ref.quality;
  var uniqueSources = getUniqueSources(sources);
  var needShowQualitySettings = quality && uniqueSources.length > 1;
  return speed || needShowQualitySettings;
};

var getControls = function getControls(playbar, bigPlayButton, sources) {
  var isSettingsExists = checkSettingsExists(playbar, sources);
  var canDownload = checkCanDownload(sources);
  var mappedPlaybar = !canDownload ? _objectSpread(_objectSpread({}, playbar), {}, {
    download: false
  }) : playbar;

  var allControls = _objectSpread({
    bigPlayButton: bigPlayButton,
    settings: isSettingsExists
  }, mappedPlaybar);

  return filterControls(allControls);
};

var mapConfigs = function mapConfigs(configs, sources) {
  var playbar = configs.playbar,
      bigPlayButton = configs.bigPlayButton,
      end = configs.end,
      other = _objectWithoutProperties(configs, ["playbar", "bigPlayButton", "end"]);

  if (!playbar) return;
  var controls = getControls(playbar, bigPlayButton, sources);
  var afterPlayed = end ? endBehaviorMap[end] : endBehaviorMap['showLastFrame'];
  return _objectSpread(_objectSpread({
    controls: controls
  }, afterPlayed), other);
};

export default mapConfigs;